import API from '../services/api';

export const getAssets = async () => {
  const res = await API.get('/asset');
  return res.data;
};

export const getAssetById = async (id: string) => {
  const res = await API.get(`/asset/${id}`);
  return res.data;
};
